import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/FAQPage.css';

const FAQPage = () => {
  return (
    <div className="faq-container">
      <div className="faq-header">
        <h1>HOW TO PLAY</h1>
        <p className="faq-subtitle">KOMOK Stock Market Party</p>
      </div>

      {/* Timeline - Visual */}
      <section className="faq-section timeline-section">
        <h2>PARTY TIMELINE</h2>
        <div className="timeline">
          <div className="timeline-item premarket">
            <div className="time-block">
              <span className="time">6:45 PM</span>
              <span className="duration">45 min</span>
            </div>
            <div className="event-block">
              <span className="event-name">PREMARKET / REGISTRATION</span>
              <span className="event-desc">Get your badge, open your trading account</span>
            </div>
          </div>

          <div className="timeline-item orientation">
            <div className="time-block">
              <span className="time">7:20 PM</span>
              <span className="duration">10 min</span>
            </div>
            <div className="event-block">
              <span className="event-name">ORIENTATION VIDEO</span>
              <span className="event-desc">Learn the rules, understand the game</span>
            </div>
          </div>

          <div className="timeline-item opening-bell">
            <div className="time-block">
              <span className="time">7:30 PM</span>
            </div>
            <div className="event-block">
              <span className="event-name">OPENING BELL</span>
              <span className="event-desc">Markets open!</span>
            </div>
          </div>

          <div className="timeline-item trading">
            <div className="time-block">
              <span className="time">7:30 PM</span>
              <span className="duration">35 min</span>
            </div>
            <div className="event-block">
              <span className="event-name">ASIAN SESSION</span>
              <span className="event-desc">First trading session</span>
            </div>
          </div>

          <div className="timeline-item game">
            <div className="time-block">
              <span className="time">8:05 PM</span>
              <span className="duration">~45 min</span>
            </div>
            <div className="event-block">
              <span className="event-name">PORTFOLIO WARFARE</span>
              <span className="event-desc">Team competition</span>
            </div>
          </div>

          <div className="timeline-item trading">
            <div className="time-block">
              <span className="time">8:50 PM</span>
              <span className="duration">35 min</span>
            </div>
            <div className="event-block">
              <span className="event-name">EUROPEAN SESSION</span>
              <span className="event-desc">Trading resumes</span>
            </div>
          </div>

          <div className="timeline-item game">
            <div className="time-block">
              <span className="time">9:25 PM</span>
              <span className="duration">~45 min</span>
            </div>
            <div className="event-block">
              <span className="event-name">DEAD CAT BOUNCE</span>
              <span className="event-desc">Team competition</span>
            </div>
          </div>

          <div className="timeline-item trading">
            <div className="time-block">
              <span className="time">10:10 PM</span>
              <span className="duration">35 min</span>
            </div>
            <div className="event-block">
              <span className="event-name">CANADIAN SESSION</span>
              <span className="event-desc">Trading resumes</span>
            </div>
          </div>

          <div className="timeline-item game mystery">
            <div className="time-block">
              <span className="time">10:45 PM</span>
              <span className="duration">~10 min</span>
            </div>
            <div className="event-block">
              <span className="event-name">CIRCUIT BREAKER</span>
              <span className="event-desc">Cake cutting</span>
            </div>
          </div>

          <div className="timeline-item game">
            <div className="time-block">
              <span className="time">10:55 PM</span>
              <span className="duration">~30 min</span>
            </div>
            <div className="event-block">
              <span className="event-name">A BRIEF CASE</span>
              <span className="event-desc">Team competition</span>
            </div>
          </div>

          <div className="timeline-item trading power-hour">
            <div className="time-block">
              <span className="time">11:25 PM</span>
              <span className="duration">5 min</span>
            </div>
            <div className="event-block">
              <span className="event-name">POWER HOUR</span>
              <span className="event-desc">Final 5-min trading frenzy!</span>
            </div>
          </div>

          <div className="timeline-item closing-bell">
            <div className="time-block">
              <span className="time">11:30 PM</span>
            </div>
            <div className="event-block">
              <span className="event-name">CLOSING BELL</span>
              <span className="event-desc">Markets close - no more trading!</span>
            </div>
          </div>

          <div className="timeline-item finale">
            <div className="time-block">
              <span className="time">~11:30 PM</span>
            </div>
            <div className="event-block">
              <span className="event-name">WINNERS</span>
              <span className="event-desc">Final standings + winner announced!</span>
            </div>
          </div>
        </div>
      </section>

      {/* Trading Basics */}
      <section className="faq-section">
        <h2>TRADING BASICS</h2>
        <div className="faq-grid">
          <div className="faq-card">
            <div className="faq-icon">💵</div>
            <h3>Starting Cash</h3>
            <p>Everyone starts with $10,000</p>
          </div>
          <div className="faq-card">
            <div className="faq-icon">📈</div>
            <h3>Long Position</h3>
            <p>Bet price goes UP. Profit when it rises.</p>
          </div>
          <div className="faq-card">
            <div className="faq-icon">📉</div>
            <h3>Short Position</h3>
            <p>Bet price goes DOWN. Profit when it falls.</p>
          </div>
          <div className="faq-card">
            <div className="faq-icon">⚡</div>
            <h3>Your Trades Matter</h3>
            <p>Buying pushes prices up, selling pushes them down.</p>
          </div>
        </div>
      </section>

      {/* How to Win */}
      <section className="faq-section">
        <h2>HOW TO WIN</h2>
        <div className="win-info">
          <div className="win-item">
            <span className="win-number">1</span>
            <div className="win-text">
              <h3>Trade Smart</h3>
              <p>Buy low, sell high. Watch the market events.</p>
            </div>
          </div>
          <div className="win-item">
            <span className="win-number">2</span>
            <div className="win-text">
              <h3>Win Games</h3>
              <p>Macro games award $10K-$50K+ in cash bonuses.</p>
            </div>
          </div>
          <div className="win-item">
            <span className="win-number">3</span>
            <div className="win-text">
              <h3>Scan Bonuses</h3>
              <p>Win a game? Scan the QR code for instant cash!</p>
            </div>
          </div>
          <div className="win-item">
            <span className="win-number">4</span>
            <div className="win-text">
              <h3>Highest Value Wins</h3>
              <p>Portfolio = Cash + Positions. Most money wins.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Tips */}
      <section className="faq-section">
        <h2>QUICK TIPS</h2>
        <ul className="tips-list">
          <li>Don't put all your money in one stock</li>
          <li>Close losing positions before they drain you</li>
          <li>Market events can crash or boost prices suddenly</li>
          <li>Check the leaderboard to see where you stand</li>
          <li>Game winnings can completely flip the rankings</li>
        </ul>
      </section>

      {/* Back Button */}
      <div className="faq-footer">
        <Link to="/home" className="back-btn">BACK TO HOME</Link>
      </div>
    </div>
  );
};

export default FAQPage;
